export default {
  p: { x: 272, y: 255, b: 'ew', d: 100 },
  r: 30,
  s: [
    { x: 100, y: 450, b: 'ew', d: 100 },
    { x: 400, y: 200, b: 'ew', d: -200 },
  ],
  b: [
    { x: 260, y: 220, b: 'ew', d: 100 },

    { x: 600, y: 520, b: 'ew', d: 80 },
  ],
  g: [{ x: 600, y: 700 }],
  h: [
    { x: 200, y: 400 },
    { x: 600, y: 50 },
  ],
};
